import * as React from "react";
import * as _ from "lodash";
import {FormElement, AbstractInputElement} from "./FormInput";
import {KitFieldKind} from "./kitFieldRegistry";


export class FormTextArea extends AbstractInputElement<string,FormElement<string,React.TextareaHTMLAttributes<any>>,{}> {

    getDefaultValue() : string {
        return "";
    }
    kind() : KitFieldKind {
        return "textarea";
    }
    render() {
        let rest : React.TextareaHTMLAttributes<any> = _.omit(this.props,['validators',`model`, `fieldSet`, `modelValue`, `valid`, 'validationMap']);
        return <textarea {...rest} data-model={this.props.model} data-field-id={this.fieldId} className={this.getClassNames()} value={this.getModelValue()} onChange={this.handleChange.bind(this)}></textarea>
    }

}

